webClient.controller('FlightBooking', ['$scope', '$window', '$timeout', '$location', '$i18next', 'tseApiClient', 'tseUtil', 'tseAirResultsHelper', 'bookingRequest', 'insurancesSelected', 'bookingRequestKey', 'insuranceOnce', 'purchaseResponse', 'trackingService', 'gtmProduct', 'userInfoResult', 'additionalData', 'omnitureService',
    function ($scope, $window, $timeout, $location, $i18next, tseApiClient, tseUtil, airHelper, bookingRequest, insurancesSelected, bookingRequestKey, insuranceOnce, purchaseResponse, trackingService, gtmProduct, userInfoResult, additionalData, omnitureService) {
        $scope.accommodationIsReady = false;
        //Initialize Variables
        $scope.getText = function (key) { return window.culture.texts[key]; };
        $scope.apiClient = tseApiClient.createClient($window.site.apiUrl, $window.site.apiUrlSSL);
        var searchUrl = $window.site.currentAirRequest.searchUrl + "?" + tseUtil.Location.getQueryString();
        var user = window.site;
        var existWonderboxCode = user && user.loginInfo && user.loginInfo.Code != null && user.loginInfo.Code != undefined;
        $scope.siteType = $window.site.type;
        $scope.requestSummary = $window.site.currentAirRequest.summary;
        $scope.requestSummary = $window.site.currentAirRequest.summary;
        $scope.searchForm = {};
        $scope.initialPriceValue = 0;
        $scope.searchForm.type = $scope.requestSummary.roundTrip ? 0 : $scope.requestSummary.oneWay ? 1 : 2;
        $scope.searchForm.cabin = $scope.requestSummary.cabinClass;
        $scope.searchForm.origin = $scope.requestSummary.origin.name;
        $scope.searchForm.origin_value = $scope.requestSummary.origin.value;
        $scope.searchForm.destination = $scope.requestSummary.destination.name;
        $scope.searchForm.destination_value = $scope.requestSummary.destination.value;
        $scope.searchForm.goDate = $scope.requestSummary.goDate.dateString;
        $scope.searchForm.adults = $scope.requestSummary.adults;
        $scope.searchForm.childrens = $scope.requestSummary.childs;
        $scope.searchForm.infants = $scope.requestSummary.infants;
        $scope.siteIsB2b = user.isLogged && user.type == 2;
        $scope.bkgDataKey = "";
        $scope.currentBkgData = tseUtil.Session.get('bkgData_' + $window.site.currentAirRequest.requestId);
        $scope.assistanceRequests = null;
        $scope.hideSpecialRequest = $window.enableSpecialRequest && $window.specialRequestAccountNumbers.length > 0 ? !$window.specialRequestAccountNumbers.includes($window.site.loginInfo.Client.AccountNumber) : true;
        // $scope.requestSummary = $scope.currentBkgData.request;

        $window.$scope = $scope;
        $scope.enableFreeFlex = $window.enableFreeFlex === true;
        $scope.selectDocumentsLanguage = lng.substring(0, 2).toUpperCase();
        var elkService = new window.Typescript.Services.ElasticSearchService();
        //Flags
        $scope.enablePaypal = $window.enablePaypal;
        $scope.enableBrandedFares = $window.enableBrandedFares;
        $scope.enableSendParameters = $window.enableSendParameters;
        if ($window.hideInsurance) $scope.hideInsurance = true;
        else $scope.hideInsurance = false;
        if ($window.isAirbus) $scope.isAirbus = $window.isAirbus;

        //block navgation if mismatch beetween paxtypes from hotel and flight
        $scope.invalidPaxTypes = false;

        //never show flexy when searching flight + hotel
        $scope.hideFlexy = $window.sessionStorage.getItem('forceUpsell') === 'true' || $window.getUrlVars()['upsell'] === 'true';
        var siteTypeIsB2b = $scope.siteType === 2;

        $.getScript("/Global/js/widgets/mrfly-widget-loader.js").done(function () {

        }).fail(function (jqxhr, settings, exception) {
            console.log(exception);
        });


        $window.FLoading({ vAction: 'show' });
        $(".c-footer").addClass("d-none");

        //save url for meta search back custom behaviour
        window.sessionStorage.setItem('currentAirRequestresultsUrl', window.site.currentAirRequest.resultsUrl);


        //Get data from session storage

        var bkgData = tseUtil.Session.get('bkgData_' + $window.site.currentAirRequest.requestId);

        var setSearchForm = function () {
            var currentSearch = $scope.searchForm;
            currentSearch.key = $window.flightHistory.createKey(currentSearch);
            currentSearch.requestId = $scope.requestSummary.requestId;
            var referrer = document.referrer;

            var lastSearch = $window.flightHistory.loadLastSearch();
            if (lastSearch && !/airprebook/i.test(referrer)) {
                console.log("LASTSEARCH FOUND");
                console.log(lastSearch);
                if (lastSearch.origin_value == currentSearch.origin_value)
                    currentSearch.origin = lastSearch.origin;
                if (lastSearch.destination_value == currentSearch.destination_value)
                    currentSearch.destination = lastSearch.destination;
                if (lastSearch.origin2_value == currentSearch.origin2_value)
                    currentSearch.origin2 = lastSearch.origin2;
                if (lastSearch.destination2_value == currentSearch.destination2_value)
                    currentSearch.destination2 = lastSearch.destination2;
                $window.flightHistory.bindView(lastSearch);
                //$window.flightHistory.setPaxView(currentSearch.adults, currentSearch.childrens, currentSearch.infants);
            }
            else {
                console.log("LASTSEARCH NOT FOUND");
                //$window.flightHistory.bindView(currentSearch);
                $window.flightHistory.loadFromMetaSearch($scope.bkgData.request);
            }
            $window.flightHistory.setPaxView(currentSearch.adults, currentSearch.childrens, currentSearch.infants);
            console.log("CURRENTSEARCH IS");
            console.log(currentSearch);

            if (window.site.partnerId === "servair") {

                if (!window.mrflyWidgets["mrfly-widget-search-engine"]) {
                    if ($('#search-engine-widget').length > 0) {
                        $.getScript("/Global/js/widgets/mrfly-widget-search-engine.js");
                    }
                }

            }

            //$window.flightHistory.bindView(currentSearch);
            //$window.flightHistory.bindView(lastSearch);
            //$window.flightHistory.setPaxView(currentSearch.adults, currentSearch.childrens, currentSearch.infants);
            // $(".c-search input[name='adults']").val(currentSearch.adults);
            // $(".c-search  input[name='childs']").val(currentSearch.childrens);
            // $(".c-search input[name='infants']").val(currentSearch.infants);
        };





        var purchaseNew = function (data, adults, childs, infants) {
            var request_id = data.RequestId.split('-').join('');
            var _adults = parseInt(adults);
            var _childs = parseInt(childs);
            var _infants = parseInt(infants);
            var rawUrl = "";
            $scope.requestSummary.requestId = request_id;
            $scope.requestSummary.adults = _adults;
            $scope.requestSummary.childs = _childs;
            $scope.requestSummary.infants = _infants;
            $scope.requestSummary.totalPaxes = _adults + _childs + _infants;
            $scope.bkgDataKey = 'bkgData_' + $scope.requestSummary.requestId;


            var _bookingUrl = $window.site.currentAirRequest.bookingUrl;
            var _paymentUrl = $window.site.currentAirRequest.paymentUrl;
            var _upsellProducts = $window.site.currentAirRequest.upsellProducts;
            var _upsellProductsRedirect = $window.site.currentAirRequest.upsellProductsRedirect;
            var _regex = /[a-f0-9]{8}(?:[a-f0-9]{4}){3}[a-f0-9]{12}/;
            if (_bookingUrl.match(_regex)) {
                var result = _bookingUrl.replace(_regex, request_id);
                $window.site.currentAirRequest.bookingUrl = result;
            }

            if (_paymentUrl.match(_regex)) {
                var result = _paymentUrl.replace(_regex, request_id);
                $window.site.currentAirRequest.paymentUrl = result;
            }

            if (_upsellProducts.match(_regex)) {
                var result = _upsellProducts.replace(_regex, request_id);
                $window.site.currentAirRequest.upsellProducts = result;
            }

            if (_upsellProductsRedirect.match(_regex)) {
                var result = _upsellProductsRedirect.replace(_regex, request_id);
                $window.site.currentAirRequest.upsellProductsRedirect = result;
            }

            var bookingData = {
                key: $scope.bkgDataKey,
                value: {
                    purchaseRequest: data.PurchaseRQ,
                    outboundKey: data.Outbound.Key,
                    request: $scope.requestSummary,
                    cabinclasses: $scope.requestSummary.cabinClass
                }
            };

            if (data.Inbound != null) {
                bookingData.value.inboundKey = data.Inbound.Key;
            }

            var upsellParam = $window.getUrlVars()['upsell'];
            var isUpsell = typeof upsellParam !== 'undefined' && upsellParam === 'true';

            if ($window.site.onSecureScheme) {
                tseUtil.Session.set(bookingData.key, bookingData.value);

                if ($window.enableUpSellProducts && $scope.requestSummary.roundTrip) {
                    $window.location.href = $window.site.currentAirRequest.upsellProducts;
                }
                else if (isUpsell) {

                    var bkgData = tseUtil.Session.get('bkgData_' + $window.site.currentAirRequest.requestId);

                    if (bkgData) {

                        var purchaseResponse = { value: "" };

                        //New Purchase Transaction
                        if (data && data.message == null) {

                            //If not hotelpropose
                            if (data.proposeHotel == false || data.proposeHotel == undefined) {
                                $window.location.href = $window.site.currentAirRequest.bookingUrl;
                                return;
                            }

                            if (data.proposals[0].flexies && data.proposals[0].flexies.length > 0) {
                                $scope.enableFreeFlex = data.proposals[0].flexies[0].propose === 2;
                            }

                            airHelper.preparePurchaseData(data);
                            bkgData.purchaseResponse = data;

                            purchaseResponse.value = data;
                            bkgData.severalProposals = bkgData.purchaseResponse.proposals.length > 1;
                            $scope.lastDate = bkgData.purchaseResponse.itineraries[bkgData.purchaseResponse.itineraries.length - 1].arrivalDateTime;

                            keyGenerated = bkgData.request.requestId + "_" + bkgData.purchaseRequest.index + "_" + bkgData.purchaseRequest.group + "_" + bkgData.purchaseRequest.proposal;
                            tseUtil.Session.set("purchaseResponse_" + keyGenerated, data);

                            var keyGenerated = bkgData.request.requestId + "_" + bkgData.purchaseRequest.index + "_" + bkgData.purchaseRequest.group + "_" + bkgData.purchaseRequest.proposal;
                            console.log(keyGenerated);

                            // BookingRequest  Object to send to API
                            bkgData.bookingRequest = {
                                proposalIndex: "",
                                bagChanged: false,
                                requestId: bkgData.request.requestId,
                                flexyFare: false,
                                insurance: null,
                                passengers: [],
                                additionalData: [],
                                buyer: {},
                                contact: { mail: '', phone: '' },
                                bestPriceFare: false
                            };

                            //Pax Init
                            var paxAmount = [bkgData.request.adults, bkgData.request.childs, bkgData.request.infants];
                            keyGenerated = "";
                            var init = true;

                            for (var ptc in paxAmount) {
                                if (paxAmount.hasOwnProperty(ptc)) {
                                    for (var i = 0; i < paxAmount[ptc]; i++) {
                                        bkgData.bookingRequest.passengers.push({ paxType: ptc });
                                    }
                                }
                            }

                            if (init) {
                                airHelper.preparePassengersData(bkgData.bookingRequest.passengers, bkgData.purchaseResponse);
                            }

                            var upsellProductsRedirect = $window.site.currentAirRequest.upsellProductsRedirect.replace(/&code=\d/i, null);
                            var redirectUrl = $window.hotelUpSellProductRedirect;

                            //avoid double slash in the url
                            if (/\/$/.test(redirectUrl) === false) {
                                redirectUrl += "/";
                            }

                            redirectUrl += "redirect.htm?purchaseId=" + bkgData.purchaseResponse.purchaseId + "&requestId=" + bkgData.request.requestId + "&redirect=" + encodeURIComponent(upsellProductsRedirect);

                            //B2B
                            if ($window.site.type === 2) {
                                redirectUrl += "&mid=" + $window.site.loginInfo.Agent.AgentId;
                                redirectUrl += "&lid=" + $window.site.loginInfo.LoginId;
                            }

                            //HOTEL TIMER: save koedia redirection time to init timer later
                            var timerkey = "hoteltimerstart_" + bkgData.purchaseResponse.purchaseId;
                            $window.sessionStorage.setItem(timerkey, new Date());

                            //$window.location.href = redirectUrl;
                            rawUrl = redirectUrl;
                            //return finalUrl;
                        }
                        else {
                            //$window.location.href = $window.site.errorsUrls.GeneralError;
                            // return $window.site.errorsUrls.GeneralError;
                            rawUrl = $window.site.errorsUrls.GeneralError;
                        }
                    }
                }
                else {
                    //$window.location.href = $window.site.currentAirRequest.bookingUrl;
                    //return $window.site.currentAirRequest.bookingUrl;
                    rawUrl = $window.site.currentAirRequest.bookingUrl;

                }
            }
            else {
                $window.sslFrame.sendCmd("setSessionStorage", bookingData,
                    function (data) {
                        tseUtil.Debug.log("BookingSession created!");
                        if ((window.enableUpSellProducts || isUpsell) && $scope.requestSummary.roundTrip) {
                            //$window.location.href = $window.site.currentAirRequest.upsellProducts;
                            // return $window.site.currentAirRequest.upsellProducts;                            
                            rawUrl = $window.site.currentAirRequest.upsellProducts;
                        } else {
                            //$window.location.href = $window.site.currentAirRequest.bookingUrl;
                            // return $window.site.currentAirRequest.bookingUrl;
                            rawUrl = $window.site.currentAirRequest.bookingUrl;

                        }
                    });
            }

            var url = new URL(rawUrl);
            var query_string = url.search;
            var search_params = new URLSearchParams(query_string);
            search_params.set('adults', _adults);
            search_params.set('childs', _childs);
            search_params.set('infants', _infants);
            url.search = search_params.toString();
            var new_url = url.toString();
            return new_url;
        };

        $scope.processShopBot = function (data, adults, childs, infants) {
            $scope.bkgData.purchaseResponse.adult = adults;
            $scope.bkgData.purchaseResponse.child = childs;
            $scope.bkgData.purchaseResponse.infant = infants;
            $scope.$apply();
            if (data.PurchaseRS != null) {
                $scope.bkgData.prixTotal.int = data.PurchaseRS.Proposals[0].TotalAmount.Integer;
                $scope.bkgData.prixTotal.dec = data.PurchaseRS.Proposals[0].TotalAmount.Decimal;
                $scope.loader.$store.commit("hideLoader");
                var url = purchaseNew(data, adults, childs, infants);
                $scope.$apply();
                $('[data-remodal-id="modal-proposal-available"]').addClass("remodal");
                $('[data-remodal-id="modal-proposal-available"]').remodal({ hashTracking: false }).open();
                $(document).on('confirmation', '[data-remodal-id="modal-proposal-available"]', function () {
                    console.log('Confirmation remodal available');
                    $window.location.href = url;
                });
            }
            else {
                $scope.loader.$store.commit("hideLoader");
                $('[data-remodal-id="modal-proposal-notavailable"]').addClass("remodal");
                $('[data-remodal-id="modal-proposal-notavailable"]').remodal({ hashTracking: false }).open();
                $(document).on('cancellation', '[data-remodal-id="modal-proposal-notavailable"]', function () {
                    console.log('Confirmation remodal notavailable');
                    if (!document.getElementById("i-search").hasAttribute("action")) {
                        document.getElementById("i-search").setAttribute("action", "/airsearch");
                    }
                    document.getElementById('i-search').submit();
                });
                $(document).on('confirmation', '[data-remodal-id="modal-proposal-notavailable"]', function () {
                    console.log("onGoBackOnSelection");
                    $window.location.reload();
                });
            }
        };

        var resumeSearch = function () {
            var btn = document.getElementById("i-search-btn");

            if (btn != null) {
                btn.removeAttribute("onclick");
                $scope.loader = mrflyWidgets['shopbot-waiting-loader'];
                //btn.setAttribute("onclick","");
                //$("#i-search-btn")[0].onclick = null;
                $("#i-search-btn").click(function () {

                    var paxvalue = document.getElementById("paxsearch");
                    var genuinevalue = document.getElementById("genuinesearch");
                    if (paxvalue == null && genuinevalue == null) {
                        if (!document.getElementById("i-search").hasAttribute("action")) {
                            document.getElementById("i-search").setAttribute("action", "/airsearch");
                        }
                        document.getElementById('i-search').submit();
                    }
                    else if ((genuinevalue.value === "true") || ((genuinevalue.value === "false") && (paxvalue.value === "false"))) {
                        if (!document.getElementById("i-search").hasAttribute("action")) {
                            document.getElementById("i-search").setAttribute("action", "/airsearch");
                        }
                        document.getElementById('i-search').submit();
                    }
                    else {
                        var origin = document.getElementsByName("origin")[0].value;
                        var destination = document.getElementsByName("destination")[0].value
                        var vAdults = document.getElementsByName('adults')[0].value;
                        var vChilds = document.getElementsByName('childs')[0].value;
                        var vInfants = document.getElementsByName('infants')[0].value;
                        var apiToken = getCookie("authToken_" + window.site.partnerId);
                        var vGoDate = document.getElementsByName('goDate')[0].value;
                        var cabinClass = document.getElementsByName('cabinClass')[0].value;
                        var vReturnDate = document.getElementsByName('returnDate')[0].value;
                        document.getElementById("i-search").removeAttribute("action");
                        var outboundKey = $scope.currentBkgData.outboundKey;
                        var inboundKey = "";
                        if ($scope.currentBkgData.inboundKey != null) {
                            inboundKey = $scope.currentBkgData.inboundKey;
                        }
                        $scope.loader.$store.commit("showLoader");
                        $.ajax({
                            url: '/shopbot/resume',
                            type: 'get',
                            data: {
                                origin: origin,
                                token: apiToken,
                                destination: destination,
                                adults: vAdults,
                                childs: vChilds,
                                infants: vInfants,
                                godate: vGoDate,
                                returndate: vReturnDate,
                                currentInboundKey: inboundKey,
                                currentOutboundKey: outboundKey,
                                cabinclass: cabinClass
                            },
                            success: function (data) {
                                $window.flightHistory.saveSearch();
                                $scope.processShopBot(data, vAdults, vChilds, vInfants);
                            },
                            error: function (result, status, error) {
                                console.log(status);
                                console.log(error);
                            }
                        });
                        // $.getScript("/Global/js/widgets/mrfly-widget-loader.js").done(function(){

                        // });
                        console.log("SHOPBOT CALL DONE");
                        return false;
                    }
                });
            }
        };

        $scope.$on('setSearchForm',
            function () {
                setTimeout(function () {
                    setSearchForm();
                    resumeSearch();
                    $window.flightHistory.waitForSearch();
                }, 2000);
            }
        );


        bkgData.totalBasketPrice = function () {
            if ($scope.bkgData.accommodations && $scope.bkgData.accommodations.any()) {
                //never ever use totalPriceForcedPrice in B2B!
                if (siteTypeIsB2b) {
                    //var margin = Math.ceil($scope.bkgData.accommodations[0].totalPriceRacknet * ($scope.bkgData.bookingRequest.partnerHotelMargin / 100));
                    return $scope.bkgData.prixTotal.value + $scope.bkgData.accommodations[0].totalPriceRacknet + $scope.bkgData.agencyMarginHotel.value;
                }
                else {
                    return $scope.bkgData.prixTotal.value + $scope.bkgData.accommodations[0].totalPriceForcedPrice;
                }
            } else {
                return $scope.bkgData.prixTotal.value;
            }
        };

        $scope.bkgData = bkgData;

        $(document).on('gotuserinfo', function (event, data, forceUpdate) {

            //autocomplete
            if (data && $scope.bkgData.bookingRequest) {
                $scope.bkgData.bookingRequest.buyer = data.userInfos.buyer;
                $scope.bkgData.bookingRequest.contact = data.userInfos.contact;
                if (forceUpdate) {
                    $scope.$apply();
                }
            }
        });


        $scope.$watch('bkgData', function () {
            $(document).trigger('gotuserinfo', $window.userInfoResult, false);
        });


        $scope.$on('countryLanguageChanged', function (event, args) {
            $scope.selectDocumentsLanguage = args;
        });



        $scope.prepareAccommodation = function (accommodation) {
            //nights number
            var nights = moment(accommodation.to).diff(moment(accommodation.from), "days");
            accommodation.nightNumber = nights;

            var adultNumber = 0;
            var childNumber = 0;
            var infantNumber = 0;

            //roomplan
            for (i = 0; i < accommodation.rooms.length; i++) {
                var roomPlan = accommodation.rooms[i].roomPlan;

                accommodation.rooms[i].adultNumber = parseInt(roomPlan.substr(0, 1));
                accommodation.rooms[i].childNumber = parseInt(roomPlan.substr(1, 1));
                accommodation.rooms[i].infantNumber = parseInt(roomPlan.substr(2, 1));

                adultNumber += parseInt(roomPlan.substr(0, 1));
                childNumber += parseInt(roomPlan.substr(1, 1));
                infantNumber += parseInt(roomPlan.substr(2, 1));
            }

            accommodation.hasValidPaxTypes = $scope.paxAmount[0] === adultNumber && $scope.paxAmount[1] === childNumber && $scope.paxAmount[2] === infantNumber;

            $scope.invalidPaxTypes = !accommodation.hasValidPaxTypes;

        };

        $scope.LoadVueJsWidgets = function (purchaseResponse) {


            //TODO 0: Get purchase and check if Accommodation
            var getPurchaseRQ = {
                purchaseId: purchaseResponse.purchaseId,
                requestId: $scope.bkgData.request.requestId,
                ceUser: $window.site.loginInfo.Matricule
            };

            $scope.apiClient.ACCOMMODATION.getPurchase(getPurchaseRQ).success(function (data) {

                if (data.accommodations.any()) {

                    //HOTEL TIMER
                    var timerkey = "hoteltimerstart_" + purchaseResponse.purchaseId;
                    if (!$window.hoteltimer && window.sessionStorage.getItem(timerkey)) {
                        var timerdate = window.sessionStorage.getItem(timerkey);

                        var diff = moment(new Date()).diff(moment(timerdate));
                        //var diffMinutes = moment.duration(diff).asMinutes();
                        var limit = 15 * 60000; //convert into ms

                        if (diff < limit) {
                            var timeoutId = setTimeout(function () { console.log("trigger alert"); }, limit - diff);
                            window.sessionStorage.setItem('hoteltimerid', timeoutId);//stored to be used when calling clearTimeout()
                        }
                    }

                    var accommodationKey = 'accommodation_' + data.accommodations[0].accommodationId;
                    var acc = $window.sessionStorage.getItem(accommodationKey);
                    if (acc) {
                        data.accommodations[0] = JSON.parse(acc);
                    }

                    $scope.accommodation = data.accommodations[0];
                    $window.accommodation = data.accommodations[0];
                    $scope.bkgData.accommodations = data.accommodations;

                    var marginHotel = 0;
                    if (data.agencyMarginHotel) {

                        if ($scope.bkgData.purchaseResponse.proposalsRequested.totalAgencyHotelMargin) {
                            var m = $scope.bkgData.purchaseResponse.proposalsRequested.totalAgencyHotelMargin.value;
                            marginHotel = Math.ceil(data.accommodations[0].totalPriceRacknet * (m / 100));
                        }
                        else {
                            marginHotel = Math.ceil(data.accommodations[0].totalPriceRacknet * (data.agencyMarginHotel.margin / 100));
                        }

                        //required to be saved in sessionstorage
                        bkgData.agencyMarginHotel = {
                            margin: data.agencyMarginHotel.margin,
                            value: marginHotel
                        };


                        $scope.bkgData.agencyMarginHotel = bkgData.agencyMarginHotel;
                    }

                    $scope.prepareAccommodation(data.accommodations[0]);

                    $.getScript("/Global/js/widgets/mrfly-widget-accommodation-info.js").done(function () {

                        mrflyWidgets['mrfly-widget-accommodation-info'].locale = $window.lng.substring(0, 2);
                        mrflyWidgets['mrfly-widget-accommodation-info'].accommodation = data.accommodations[0];
                        mrflyWidgets['mrfly-widget-accommodation-info'].siteType = window.site.type;
                        mrflyWidgets['mrfly-widget-accommodation-info'].agencyMarginHotel = marginHotel;
                    }).fail(function (jqxhr, settings, exception) {
                        console.log(exception);
                    });



                    if ($scope.notReadyStep === 1 && $scope.invalidPaxTypes === false) {

                        $.getScript("/Global/js/widgets/mrfly-widget-accommodation-pax-form.js").done(function () {

                            var accommodationKey = 'accommodation_' + $scope.accommodation.accommodationId;

                            if ($window.sessionStorage.getItem(accommodationKey) != null) {

                                accommodation = JSON.parse($window.sessionStorage.getItem(accommodationKey));

                                $scope.prepareAccommodation(accommodation);

                                $scope.BindPaxForm(accommodation, accommodationKey, bkgData.bookingRequest.passengers);
                            }
                            else {
                                $scope.BindPaxForm(data.accommodations[0], accommodationKey, bkgData.bookingRequest.passengers);
                            }

                        }).fail(function (jqxhr, settings, exception) {
                            console.log(exception);
                        });

                    }

                    if ($scope.invalidPaxTypes === false) {

                        $.getScript("/Global/js/widgets/mrfly-widget-basket-total-price.js").done(function () {
                            mrflyWidgets['mrfly-widget-basket-total-price'].price = $scope.bkgData.totalBasketPrice();
                        });

                    }
                }
            });


        };

        $scope.BindPaxForm = function (accommodation, accommodationKey, passengers) {
            mrflyWidgets['mrfly-widget-accommodation-pax-form'].resources = i18next.store.data.dev.translation;
            mrflyWidgets['mrfly-widget-accommodation-pax-form'].accommodation = accommodation;
            mrflyWidgets['mrfly-widget-accommodation-pax-form'].paxes = passengers;
            mrflyWidgets['mrfly-widget-accommodation-pax-form'].$on('updated', function (isValid, filledAccommodation) {
                if (isValid) {
                    $("#Step1Button").show();
                    $scope.accommodation = filledAccommodation;
                    $window.accommodation = filledAccommodation;
                    $window.sessionStorage.setItem(accommodationKey, JSON.stringify(filledAccommodation));
                }
                else {
                    $("#Step1Button").hide();
                }
            });
        };


        //Check Hide insurance and hide flexy values
        if (user && user.loginInfo && siteTypeIsB2b) {
            if (user.loginInfo.HideInsurance == true) {
                $scope.hideInsurance = true;
            }

            if (user.loginInfo.HideFlexy == true) {
                $scope.hideFlexy = true;
            }
        }

        if (bkgData) {

            //Pax Init
            var paxType = ["Adulte", "Enfant", "Bébé"];
            var paxTypeAbv = ["ADT", "CNN", "INF"];
            var paxAmount = [bkgData.request.adults, bkgData.request.childs, bkgData.request.infants];
            var keyGenerated = "";
            var init = true;

            $scope.paxType = paxType;
            $scope.paxAmount = paxAmount;
            $scope.newProcess = true;
            bkgData.pricePredictions = null;

            //Key Generated: requestId_purchaseRequestIndex_purchaseRequestGroup_purchaseRequestProposal
            keyGenerated = bkgData.request.requestId + "_" + bkgData.purchaseRequest.index + "_" + bkgData.purchaseRequest.group + "_" + bkgData.purchaseRequest.proposal;

            // BookingRequest  Object to send to API
            bkgData.bookingRequest = tseUtil.Session.get("bookingRequest_" + keyGenerated);
            bkgData.paymentMethods = tseUtil.Session.get("paymentMethods" + keyGenerated);


            if (bkgData.bookingRequest != null && bkgData.bookingRequest.requestId == bkgData.request.requestId) {
                init = false;
            }

            //Initialize BookingRequest Object
            if (init) {

                //Insurance:  { company : "00001", reference: "00001" }
                //Passengers: { title, firstName, lastName, birthDate, fidelityCardType, fidelityCardNumber, foodType, passportNumber, passportExpireDate, passportCountry }                       
                bkgData.bookingRequest = {
                    proposalIndex: "",
                    bagChanged: false,
                    requestId: bkgData.request.requestId,
                    flexyFare: false,
                    insurance: null,
                    passengers: [],
                    additionalData: [],
                    buyer: {},
                    contact: { mail: '', phone: '' },
                    bestPriceFare: false
                };

                if (existWonderboxCode)
                    bkgData.bookingRequest.wonderboxCode = user.loginInfo.Code;

                //autocomplete
                //if (userInfo && userInfo.isLogged && userInfo.userInfos) {
                //    //pas d'autocomplete pour les passagers 
                //    //bkgData.bookingRequest.passengers.push(userInfo.userInfos.passenger);
                //    bkgData.bookingRequest.buyer = userInfo.userInfos.buyer;
                //    bkgData.bookingRequest.contact = userInfo.userInfos.contact;
                //}

                var idx = 0;

                for (var ptc in paxAmount) {

                    if (paxAmount.hasOwnProperty(ptc)) {
                        for (var i = 0; i < paxAmount[ptc]; i++) {
                            bkgData.bookingRequest.passengers.push({ paxType: ptc, ptc: paxTypeAbv[ptc], index: idx });
                            idx++;
                        }
                    }

                }
            }

            var purchaseResponse = tseUtil.Session.get("purchaseResponse_" + keyGenerated);


            //Get values from session storage
            var _insuranceSelected = tseUtil.Session.get("insurancesSelected_" + keyGenerated);
            var _insuranceOnce = tseUtil.Session.get("insuranceOnce" + keyGenerated);
            var _purchaseResponse = tseUtil.Session.get("purchaseResponse_" + keyGenerated);
            //console.log(_purchaseResponse);
            bkgData.paypalToken = tseUtil.Session.get("paypalToken" + keyGenerated);
            bkgData.banqueCasinoSchedule = tseUtil.Session.get("banqueCasino" + keyGenerated);
            bkgData.banqueCasino = tseUtil.Session.get("banqueCasinoStatus" + keyGenerated);
            bkgData.banqueCasinoMessage = tseUtil.Session.get("banqueCasinoMessage" + keyGenerated);
            bkgData.banqueCasinoCustomerUnauthorized = tseUtil.Session.get("banqueCasinoCustomerUnauthorized" + keyGenerated);
            bkgData.showBanqueCasino = tseUtil.Session.get("banqueCasinoShowBanqueCasino" + keyGenerated);
            bkgData.paymentMethods = tseUtil.Session.get("paymentMethods" + keyGenerated);

            if ($window.sessionStorage.getItem("userInfoResult")) {

                userInfo = JSON.parse($window.sessionStorage.getItem("userInfoResult"));

                bkgData.bookingRequest.buyer = userInfo.userInfos.buyer;
                bkgData.bookingRequest.contact = userInfo.userInfos.contact;
                $scope.$apply();
            }

            if (_insuranceSelected && !init) {
                bkgData.insurancesSelected = _insuranceSelected;
                bkgData.insuranceOnce = _insuranceOnce;
            } else {
                bkgData.insurancesSelected = {};
                bkgData.insuranceOnce = 0;
            }

            //Tracking
            try {
                //GTM
                if (trackingService.isActivated()) {
                    trackingService.initDataLayer('checkout');
                }
            }
            catch (ex) {
                console.log(ex.message);
                $window.trackingError = ex.message;
            }

            var codeParam = $window.getUrlVars()['code'];
            var hotelAdded = typeof codeParam !== 'undefined' && codeParam === '1';
            var upsellParam = $window.getUrlVars()['upsell'];
            var isUpsell = typeof upsellParam !== 'undefined' && upsellParam === 'true';

            window.sessionStorage.setItem('forceUpsell', hotelAdded && isUpsell);




            //Purchase Response

            if (_purchaseResponse && !init) {
                bkgData.purchaseResponse = _purchaseResponse;
                purchaseResponse.value = _purchaseResponse;
                bkgData.severalProposals = bkgData.purchaseResponse.proposals.length > 1;
                $window.FLoading({ vAction: 'hide' });
                $(".c-footer").removeClass("d-none");

                if (bkgData.purchaseResponse != null && bkgData.purchaseResponse.itineraries != null && bkgData.purchaseResponse.itineraries.any()) {
                    $scope.lastDate = bkgData.purchaseResponse.itineraries[bkgData.purchaseResponse.itineraries.length - 1].arrivalDateTime;
                }

                //Tracking
                try {
                    $window.$scope.bkgData.request.totalAmount = purchaseResponse.value.proposals[0].totalAmount;
                    //GTM
                    if (trackingService.isActivated()) {
                        trackingService.addProduct(gtmProduct.parseRequest($scope.bkgData.request).applyPrice(purchaseResponse.value.proposals[0].totalAmount));
                        trackingService.parseScope($scope);
                        trackingService.pushDataLayer('step', 1);
                    }
                    //omniture
                    if (omnitureService.isActivated()) {
                        omnitureService.sendEvent(omnitureService.PURCHASE_1_VOL, omnitureService.FLIGHT_TUNNEL, { request: $scope.bkgData.request, totalAmount: purchaseResponse.value.proposals[0].totalAmount });
                    }
                }
                catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }
                ///If upSellProducts  is enable check for accommodation

                if ($window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true' || $window.getUrlVars()['upsell'] === 'true') {
                    var getPurchaseRQ = {
                        purchaseId: purchaseResponse.purchaseId,
                        requestId: $scope.bkgData.request.requestId,
                        ceUser: $window.site.loginInfo.Matricule
                    };
                    $scope.LoadVueJsWidgets(_purchaseResponse);
                }
                $scope.$emit("setSearchForm");


            } else if (_purchaseResponse && init) {
                bkgData.purchaseResponse = _purchaseResponse;
                purchaseResponse.value = _purchaseResponse;
                bkgData.severalProposals = bkgData.purchaseResponse.proposals.length > 1;
                $window.FLoading({ vAction: 'hide' });

                if (bkgData.purchaseResponse != null && bkgData.purchaseResponse.itineraries != null && bkgData.purchaseResponse.itineraries.any()) {
                    $scope.lastDate = bkgData.purchaseResponse.itineraries[bkgData.purchaseResponse.itineraries.length - 1].arrivalDateTime;
                }

                //If upSellProducts  is enable check for accommodation
                if ($window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true' || $window.getUrlVars()['upsell'] === 'true') {
                    $scope.LoadVueJsWidgets(_purchaseResponse);
                }
            }
            else {
                purchaseResponse = { value: "" };

                var elkMessage = window.Typescript.Services.ElasticSearchService.createMessage('PurchaseNew');

                elkMessage.requestId = $window.site.currentAirRequest.requestId;
                elkMessage.messageRequest = bkgData.purchaseRequest;
                //A changer par la config servair pour le moment on utilise 1==1
                var apiToken = getCookie("authToken_" + window.site.partnerId);
                var loginId = getCookie("lid_" + $window.site.partnerId);
                var purchaseNewServairRequest = {};
                purchaseNewServairRequest.purchaseRequest = bkgData.purchaseRequest;
                purchaseNewServairRequest.apiToken = apiToken;
                purchaseNewServairRequest.loginId = loginId;
                purchaseNewServairRequest.fare = [];


                if (window.site.partnerId === "servair") {
                    $window.Typescript.Servair.Services.ServairService.getPurchaseRequest(purchaseNewServairRequest).then(function (result) {
                     
                        var info = result.data;
                        var data = JSON.parse(info)
                        elkMessage.messageResponse = data;
                        if (data && data.message == null) {
                            console.log("DATA");
                            console.log(data);

                            airHelper.preparePurchaseData(data);
                            bkgData.purchaseResponse = data;
                            purchaseResponse.value = data;
                            bkgData.severalProposals = bkgData.purchaseResponse.proposals.length > 1;
                            bkgData.bookingRequest.proposalIndex = bkgData.purchaseResponse.proposals[0].index;
                            $scope.lastDate = bkgData.purchaseResponse.itineraries[bkgData.purchaseResponse.itineraries.length - 1].arrivalDateTime;

                            if (bkgData.severalProposals && bkgData.purchaseResponse.brandedFaresServices.length > 1)
                                airHelper.prepareBrandedFaresServicesData(bkgData.purchaseResponse.brandedFaresServices);

                            if (init)
                                airHelper.preparePassengersData(bkgData.bookingRequest.passengers, bkgData.purchaseResponse);

                            //Predictions
                            var predictions = $scope.preparePredictionsObject();
                            var counterPax = 0;
                            //clear array

                            bkgData.bookingRequest.passengers.length = 0;
                          
                            //adultes en premier
                            bkgData.purchaseResponse.ayantDroitPricing.filter(function (x) { return x.paxType == 0 }).forEach(function (passenger) {

                                bkgData.bookingRequest.passengers.push({
                                    "paxType": passenger.paxType,
                                    "ptc": "ADT",
                                    "index": counterPax,
                                    // "fidelityCardType": "00055",
                                    "baggageByItinerary": {},
                                    "firstName": passenger.fisrtName,
                                    "lastName": passenger.lastName,
                                    "title": passenger.gender ? "1" : "2", //Gender = true -> Masculin(1) / Gender = False -> Feminin (2)
                                    "birthDate": moment(passenger.birthdate).format("DD/MM/YYYY")
                                });
                                counterPax++;
                            });
                            //puis enfants
                            bkgData.purchaseResponse.ayantDroitPricing.filter(function (x) { return x.paxType == 1 }).forEach(function (passenger) {

                                bkgData.bookingRequest.passengers.push({
                                    "paxType": passenger.paxType,
                                    "ptc": "CNN",
                                    "index": counterPax,
                                    // "fidelityCardType": "00055",
                                    "baggageByItinerary": {},
                                    "firstName": passenger.fisrtName,
                                    "lastName": passenger.lastName,
                                    "title": passenger.gender ? "1" : "2", //Gender = true -> Masculin(1) / Gender = False -> Feminin (2)
                                    "birthDate": moment(passenger.birthdate).format("DD/MM/YYYY")
                                });
                                counterPax++;
                            });

                            //puis bébés
                            bkgData.purchaseResponse.ayantDroitPricing.filter(function (x) { return x.paxType == 2 }).forEach(function (passenger) {

                                bkgData.bookingRequest.passengers.push({
                                    "paxType": passenger.paxType,
                                    "ptc": "INF",
                                    "index": counterPax,
                                    // "fidelityCardType": "00055",
                                    "baggageByItinerary": {},
                                    "firstName": passenger.fisrtName,
                                    "lastName": passenger.lastName,
                                    "title": passenger.gender ? "1" : "2", //Gender = true -> Masculin(1) / Gender = False -> Feminin (2)
                                    "birthDate": moment(passenger.birthdate).format("DD/MM/YYYY")
                                });
                                counterPax++;
                            });


                            counterPax = 0;

                            //Tracking
                            try {
                                $window.$scope.bkgData.request.totalAmount = purchaseResponse.value.proposals[0].totalAmount;
                                //GTM
                                if (trackingService.isActivated()) {
                                    trackingService.addProduct(gtmProduct.parseRequest($scope.bkgData.request).applyPrice(purchaseResponse.value.proposals[0].totalAmount));
                                    trackingService.parseScope($scope);
                                    trackingService.pushDataLayer('step', 1);
                                }

                                //omniture
                                if (omnitureService.isActivated()) {
                                    omnitureService.sendEvent(omnitureService.PURCHASE_1_VOL, omnitureService.FLIGHT_TUNNEL, { request: $scope.bkgData.request, totalAmount: purchaseResponse.value.proposals[0].totalAmount });
                                }
                            }
                            catch (ex) {
                                console.log(ex.message);
                                $window.trackingError = ex.message;
                            }

                            /*train process result*/
                            angular.forEach(bkgData.purchaseResponse.itineraries, function (iti, indexI) {
                                if (iti.segments.length == 1 && iti.segments[0].equipment.reference == "TRN") $scope.bkgData.purchaseResponse.itineraries[indexI].isTrainOnly = true;
                                else {
                                    var isTrainOnly = false;
                                    for (var i = 0; i < iti.segments.length; i++) {
                                        if (iti.segments[i].equipment.reference == "TRN") isTrainOnly = true;
                                        else if (iti.segments[i].equipment.reference != "TRN") {
                                            isTrainOnly = false;
                                            break;
                                        }
                                    }
                                    $scope.bkgData.purchaseResponse.itineraries[indexI].isTrainOnly = isTrainOnly;
                                }
                            });

                            if ($scope.bkgData.purchaseResponse.itineraries.every(function (itinerary) { return itinerary.isTrainOnly === true; })) {
                                $scope.bkgData.purchaseResponse.productIsTrain = true;
                            }

                            if ($scope.bkgData.purchaseResponse.productIsTrain === true) {
                                $scope.hideInsurance = true;
                                $scope.hideFlexy = true;
                            }

                            $window.FLoading({ vAction: 'hide' });
                            $(".c-footer").removeClass("d-none");

                        }
                        else {
                            $window.location.href = $window.site.errorsUrls.GeneralError;

                        }

                    }).finally(function () {
                        $scope.$emit("setSearchForm");
                        elkService.store(elkMessage);
                        $scope.$apply();
                        //$window.location.reload(); 
                    });
                }
                else {

                    //New Purchase Transaction
                    $scope.apiClient.PURCHASE.new(bkgData.purchaseRequest)
                        .success(function (data, code) {
                            elkMessage.statusCode = code;
                            elkMessage.messageResponse = data;


                            if (data && data.message == null) {

                                console.log("DATA");
                                console.log(data);
                                if (data.proposals[0].flexies && data.proposals[0].flexies.length > 0) {
                                    $scope.enableFreeFlex = data.proposals[0].flexies[0].propose === 2;
                                }

                                airHelper.preparePurchaseData(data);
                                bkgData.purchaseResponse = data;
                                purchaseResponse.value = data;
                                bkgData.severalProposals = bkgData.purchaseResponse.proposals.length > 1;
                                bkgData.bookingRequest.proposalIndex = bkgData.purchaseResponse.proposals[0].index;
                                $scope.lastDate = bkgData.purchaseResponse.itineraries[bkgData.purchaseResponse.itineraries.length - 1].arrivalDateTime;

                                if (bkgData.severalProposals && bkgData.purchaseResponse.brandedFaresServices.length > 1)
                                    airHelper.prepareBrandedFaresServicesData(bkgData.purchaseResponse.brandedFaresServices);

                                if (init)
                                    airHelper.preparePassengersData(bkgData.bookingRequest.passengers, bkgData.purchaseResponse);
                                var predictions = $scope.preparePredictionsObject();
                                try {
                                    $window.$scope.bkgData.request.totalAmount = purchaseResponse.value.proposals[0].totalAmount;
                                    //GTM
                                    if (trackingService.isActivated()) {
                                        trackingService.addProduct(gtmProduct.parseRequest($scope.bkgData.request).applyPrice(purchaseResponse.value.proposals[0].totalAmount));
                                        trackingService.parseScope($scope);
                                        trackingService.pushDataLayer('step', 1);
                                    }

                                    //omniture
                                    if (omnitureService.isActivated()) {
                                        omnitureService.sendEvent(omnitureService.PURCHASE_1_VOL, omnitureService.FLIGHT_TUNNEL, { request: $scope.bkgData.request, totalAmount: purchaseResponse.value.proposals[0].totalAmount });
                                    }
                                }
                                catch (ex) {
                                    console.log(ex.message);
                                    $window.trackingError = ex.message;
                                }

                                /*train process result*/
                                angular.forEach(bkgData.purchaseResponse.itineraries, function (iti, indexI) {
                                    if (iti.segments.length == 1 && iti.segments[0].equipment.reference == "TRN") $scope.bkgData.purchaseResponse.itineraries[indexI].isTrainOnly = true;
                                    else {
                                        var isTrainOnly = false;
                                        for (var i = 0; i < iti.segments.length; i++) {
                                            if (iti.segments[i].equipment.reference == "TRN") isTrainOnly = true;
                                            else if (iti.segments[i].equipment.reference != "TRN") {
                                                isTrainOnly = false;
                                                break;
                                            }
                                        }
                                        $scope.bkgData.purchaseResponse.itineraries[indexI].isTrainOnly = isTrainOnly;
                                    }
                                });

                                if ($scope.bkgData.purchaseResponse.itineraries.every(function (itinerary) { return itinerary.isTrainOnly === true; })) {
                                    $scope.bkgData.purchaseResponse.productIsTrain = true;
                                }

                                if ($scope.bkgData.purchaseResponse.productIsTrain === true) {
                                    $scope.hideInsurance = true;
                                    $scope.hideFlexy = true;
                                }

                                $window.FLoading({ vAction: 'hide' });
                                $(".c-footer").removeClass("d-none");

                            }
                            else {
                                $window.location.href = $window.site.errorsUrls.GeneralError;
                            }

                        }).error(function (data, code) {
                            elkMessage.statusCode = code;
                            elkMessage.messageResponse = data;

                            $window.location.href = $window.site.errorsUrls.GeneralError;
                        }).finally(function () {
                            //$scope.$emit("setSearchForm");
                            elkService.store(elkMessage);
                        });
                }

            }

            $scope.$on("getPayPalToken", function (event, value) {
                if ($scope.enablePaypal) {
                    var paypalRQ = { itineraries: [], departureDate: '' };
                    paypalRQ.departureDate = bkgData.purchaseResponse.itineraries.first().departureDateTime;
                    bkgData.purchaseResponse.itineraries.each(function (itinerary) {
                        paypalRQ.itineraries.push(itinerary.origin.airportIata);
                        paypalRQ.itineraries.push(itinerary.destination.airportIata);
                    });

                    $scope.apiClient.getPayPalToken(paypalRQ).success(function (data) {
                        if (data)
                            bkgData.paypalToken = data.token;
                    }).error(function (data) {
                    }).finally(function () {
                    });
                }
            });

            $scope.updateScreen = function (step) {

                if ($location.hash() == "" && step == 1) {
                    //do nothing
                }
                else
                    $location.hash(step);

                console.log('hash:' + $location.hash());

                if ($location.hash() == 1 && $scope.accommodation != null) {

                    var accommodationKey = 'accommodation_' + $scope.accommodation.accommodationId;

                    if ($window.sessionStorage.getItem(accommodationKey) != null) {
                        accommodation = JSON.parse($window.sessionStorage.getItem(accommodationKey));

                        $.getScript("/Global/js/widgets/mrfly-widget-accommodation-pax-form.js").done(function () {
                            $scope.BindPaxForm(accommodation, accommodationKey, bkgData.bookingRequest.passengers);
                        });

                    }
                }

                $scope.notReadyStep = step;
                bkgData.currentStep = step;
                bookingRequest.value = bkgData.bookingRequest;
                insurancesSelected.value = bkgData.insurancesSelected;
                insuranceOnce.value = bkgData.insuranceOnce;
                bookingRequestKey.value = keyGenerated;
                purchaseResponse.value = bkgData.purchaseResponse;
                //$window.sendAnalytics('/Flightsearch/Purchase' + step, 'Purchase' + step);

                //Tracking
                try {
                    //GTM
                    if (trackingService.isActivated()) {
                        trackingService.pushPageData('/Flightsearch/Purchase' + step, 'Purchase' + step, lng, false);
                    }
                }
                catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }

                $window.sendInspectlet('virtualPage');
                $window.sendInspectlet("pageUrl", $window.getUrl('Flightsearch/Purchase' + step));
                $scope.updateBookingSummary();

                if (step == 3) {

                    //GTM
                    if (trackingService.isActivated()) {
                        if ($scope.bkgData.insuranceOnce) {
                            trackingService.addProduct(gtmProduct.parseInsurance($scope.bkgData.insurancesSelected));
                        }
                        else {
                            trackingService.removeProduct('Insurance11');
                        }
                        trackingService.parseScope($scope);
                        trackingService.pushDataLayer('step', 3);
                    }
                    //omniture
                    if (omnitureService.isActivated()) {
                        omnitureService.sendEvent(omnitureService.PURCHASE_3_VOL, omnitureService.FLIGHT_TUNNEL, null);
                    }
                }
            };

            //Update Booking Summary: Event to notify PurchaseSummary directive that there are changes
            $scope.updateBookingSummary = function () {
                $scope.$broadcast("onBookingSummaryUpdate");
            };

            $scope.$on("updateTotal", function (event, args) {

                if (args && args.partnerHotelMargin != null) {
                    var margin = Math.ceil($scope.accommodation.totalPriceRacknet * (args.partnerHotelMargin / 100));
                    mrflyWidgets['mrfly-widget-accommodation-info'].agencyMarginHotel = margin;
                    bkgData.agencyMarginHotel.margin = args.partnerHotelMargin;
                    bkgData.agencyMarginHotel.value = margin;
                }

                if (mrflyWidgets['mrfly-widget-basket-total-price'] != null) {
                    mrflyWidgets['mrfly-widget-basket-total-price'].price = $scope.bkgData.totalBasketPrice();
                }
                $scope.updateBookingSummary();
            });

            $scope.$on("selectedSeats", function (event, args) {
                $scope.updateBookingSummary();
            });

            $scope.$on("totalFlexySelected", function (event, args) {

                bkgData.totalFlexAmount = args.amount;
                bkgData.totalFlexSelected = args.selected;

                $scope.updateBookingSummary();
            });

            $scope.$on("onBookingSummaryUpdateCompleted", function (event, args) {
                $scope.prixTotalWithoutMargin = bkgData.prixTotalWithoutMargin;
                //update vue component if required
                if (typeof mrflyWidgets !== 'undefined' && mrflyWidgets != null &&
                    typeof mrflyWidgets['mrfly-widget-basket-total-price'] !== 'undefined' && mrflyWidgets['mrfly-widget-basket-total-price'] != null) {
                    mrflyWidgets['mrfly-widget-basket-total-price'].price = $scope.bkgData.totalBasketPrice();
                }
            });

            $scope.$on("onFlexyClick", function (event, args) {
                bkgData.bookingRequest.flexyFare = args.isFlexy;
                bkgData.bookingRequest.insurance = null;
                bkgData.insuranceOnce = 0;
                bkgData.insurancesSelected = {};
                $scope.updateBookingSummary();
            });

            $scope.$on("onInsuranceClick", function (event, args) {
                bkgData.insuranceOnce = 1;
                bkgData.insurancesSelected.isAnnul = {};
                bkgData.insurancesSelected.isRepatriament = {};
                bkgData.insurancesSelected.isAnnulRepatriament = {};

                if (args.amount > 0) {

                    if (args.type == "00001" || args.type == "00007") { bkgData.insurancesSelected.isAnnul = { amount: args.amount, reference: args.type, company: args.company, quantity: args.quantity } }
                    if (args.type == "00003") { bkgData.insurancesSelected.isRepatriament = { amount: args.amount, reference: args.type, company: args.company, quantity: args.quantity } }
                    if (args.type == "00004") { bkgData.insurancesSelected.isRepatriament = { amount: args.amount, reference: args.type, company: args.company, quantity: args.quantity } }
                    if (args.type == "00002") { bkgData.insurancesSelected.isAnnulRepatriament = { amount: args.amount, reference: args.type, company: args.company, quantity: args.quantity } }
                    bkgData.bookingRequest.insurance = { company: args.company, reference: args.type };
                }
                else if (args.amount === 0 && args.type === "00004" && window.partnerName === "volcdiscount") {
                    bkgData.insurancesSelected.isRepatriament = { amount: args.amount, reference: args.type, company: args.company, quantity: args.quantity };
                    bkgData.bookingRequest.insurance = { company: args.company, reference: args.type };
                }
                else if (bkgData.bookingRequest.insurance != null && args.type == bkgData.bookingRequest.insurance.reference) {
                    bkgData.bookingRequest.insurance = null;
                }

                insurancesSelected.value = bkgData.insurancesSelected;
                insuranceOnce.value = bkgData.insuranceOnce;
                $scope.updateBookingSummary();
            });

            //Update Itinerary BookingItinerary; Event to notify PurchaseSummary directive that there are changes        
            $scope.updateItinerarySummary = function () {
                $scope.$broadcast("onItinerarySummaryUpdate");
            }

            //OnLoad
            if ($location.hash() != "") {
                var normalizedHash = $location.hash().replaceAll('#', '').substring(0);
                var step = parseInt(normalizedHash);
                if (step > 0) $scope.updateScreen(step);
                else $scope.updateScreen(1);
            }
            else
                $scope.updateScreen(1);

            //Detect if hash changes.
            var hashChanged = function (callback) {
                var lastHash = $location.hash(); //window.location.hash;
                var innerFunc = function () {
                    if ($location.hash() != lastHash) {
                        lastHash = $location.hash();
                        if (callback)
                            callback(lastHash);
                    }
                    setTimeout(innerFunc, 100);
                };
                setTimeout(innerFunc, 100);
            };
            hashChanged(function (hashValue) {
                if (hashValue == "") hashValue = "#1";
                var step = parseInt(hashValue.substring(1));

                if (step > 0) {
                    $scope.$apply(function () {
                        if ($scope.notReadyStep != step) {
                            $scope.updateScreen(step);
                            setTimeout(function () {
                                $window.scrollTo(0, 0);
                            }, 100);
                        }
                    });
                }
            });

            $scope.$on("setReadyStep", function (event, args) {
                $scope.newProcess = false;

                $('#i-field-error').hide();

                if (args.step == 1) {

                    var additionalBaggagesList = [];

                    if (bkgData.bookingRequest.bagChanged) {
                        bkgData.bookingRequest.passengers.each(function (p) {
                            if (p.baggageByItinerary != null) {
                                for (var bag in p.baggageByItinerary) {
                                    if (p.baggageByItinerary[bag].quantity > 0) {
                                        additionalBaggagesList.push(p.baggageByItinerary[bag].key);
                                    }
                                }
                            }
                        });
                    }

                    bkgData.additionalBaggagesList = additionalBaggagesList;

                    //Si hay maletas adicionales seleccionadas llamamos a la transaccion PURCHASE.calculateInsurance
                    if (additionalBaggagesList.any() || bkgData.bookingRequest.bagChanged) {
                        $window.FLoading({ vAction: 'showNow' });
                        var calculateInsurance = {};
                        calculateInsurance.requestId = $scope.bkgData.bookingRequest.requestId;
                        calculateInsurance.purchaseId = $scope.bkgData.purchaseResponse.purchaseId;
                        calculateInsurance.index = $scope.bkgData.purchaseResponse.proposalsRequested.index;
                        calculateInsurance.additionalBaggages = additionalBaggagesList;

                        $scope.apiClient.PURCHASE.calculateInsurance(calculateInsurance).success(function (data) {
                            if (data && data.insurances && data.insurances.length > 0) {
                                $scope.bkgData.purchaseResponse.proposalsRequested.insurances = data.insurances;

                                //required so that the insurance rap. is reloaded
                                $scope.$broadcast("insurancesupdated");

                                bkgData.bookingRequest.bagChanged = false;
                                $window.FLoading({ vAction: 'hide' });
                                $(".c-footer").removeClass("d-none");
                            }
                            else {
                                $window.FLoading({ vAction: 'hide' });
                                $(".c-footer").removeClass("d-none");
                            }
                        }).error(function (data) { });
                    }

                    if ($scope.hideInsurance == true) {
                        var purchasePaymentMethodsRq = {
                            value: 2,
                            purchaseId: $scope.bkgData.purchaseResponse.purchaseId,
                            proposalIndex: $scope.bkgData.bookingRequest.proposalIndex,
                            passengers: $scope.bkgData.bookingRequest.passengers
                        };

                        $scope.$emit("getPurchasePaymentMethods", purchasePaymentMethodsRq);
                    }
                }

                $scope.updateScreen(args.step + 1);
                $window.scrollTo(0, $($(".c-main > div")[1]).offset().top - 15);
            });

            //Additional baggages has been changed
            $scope.$on("addBaggagesChanged", function (event, args) {
                $scope.updateBookingSummary();
                bkgData.bookingRequest.bagChanged = true;
            });

            $scope.$on("onBestPriceClick", function (event, args) {
                bkgData.bookingRequest.bestPriceFare = args.isBestPrice;
                $scope.updateBookingSummary();
            });

            $scope.$on("brandClick", function (event, args) {
                if (args.brandKey != null && args.proposalIndex != null) {
                    bkgData.bookingRequest.proposalIndex = args.proposalIndex;
                    bkgData.bookingRequest.brandKey = args.brandKey;

                    airHelper.selectProposal(args.proposalIndex, bkgData.purchaseResponse);

                    //fix brandes fares class for train
                    if ($scope.bkgData.purchaseResponse.productIsTrain === true) {
                        var reference = 0;

                        bkgData.purchaseResponse.proposals[args.proposalIndex].fares.each(function (fare) {
                            fare.itineraries.each(function (itinerary) {
                                itinerary.segments.each(function (segment) {
                                    if (segment.cabinClass.reference > reference) {
                                        reference = segment.cabinClass.reference;
                                    }
                                });
                            });
                        });

                        if (reference > 0) {
                            bkgData.request.cabinClass = reference == 1 ? 'C' : 'Y';
                        }
                    }

                    $scope.updateBookingSummary();
                    $scope.updateItinerarySummary();

                    $scope.fareWithLugage = args.fareWithLugage;
                    if (mrflyWidgets['mrfly-widget-itinerary-recap']) mrflyWidgets['mrfly-widget-itinerary-recap'].enableaddluggages = !args.fareWithLugage;
                    if (bkgData.purchaseResponse.proposalsRequested.fareWithoutBaggage == false)
                        $scope.$broadcast("onNoAddBaggagesSelection");
                }
            });

            var changePaxesAndPayer = true;
            var paxHistory = tseUtil.Session.get('flightPaxHistory');

            if (paxHistory != undefined && paxHistory.request != undefined && bkgData.request != undefined && !$scope.siteIsB2b && init) {
                if (paxHistory.request.adults != bkgData.request.adults)
                    changePaxesAndPayer = false;
                if (paxHistory.request.childs != bkgData.request.childs)
                    changePaxesAndPayer = false;
                if (paxHistory.request.infants != bkgData.request.infants)
                    changePaxesAndPayer = false;
            }
            else {
                changePaxesAndPayer = false;
            }

            if (changePaxesAndPayer) {
                bkgData.bookingRequest.passengers = paxHistory.passengers;
                if (paxHistory.buyer != undefined)
                    bkgData.bookingRequest.buyer = paxHistory.buyer;
                if (paxHistory.contact != undefined)
                    bkgData.bookingRequest.contact = paxHistory.contact;
                console.log("PaxHistory has been loaded.");
            }

            $scope.updateBookingSummary();
            bookingRequest.value = bkgData.bookingRequest;
            insurancesSelected.value = bkgData.insurancesSelected;
            insuranceOnce.value = bkgData.insuranceOnce;
            bookingRequestKey.value = keyGenerated;

            //PURCHASE Create Booking
            $scope.$on("createBooking", function (event, args) {

                //Save ecurrent url in sessionStorage for Casino 
                tseUtil.Session.set('Step3Url', window.location.href);

                // $window.FLoading({ vAction: 'show' });
                //window.mrflyWidgets['mrfly-widget-loader-component'].$store.commit("showLoader");
                window.mrflyWidgets['airbooking-process-loader'].$store.commit("showLoader");
                var argsRequest = window.objectClone(args.request);

                var bookingRQ = {
                    purchaseId: argsRequest.purchaseId,
                    requestId: argsRequest.requestId,
                    proposalIndex: argsRequest.proposalIndex,
                    contact: argsRequest.contact,
                    buyer: argsRequest.buyer,
                    passengers: [],
                    insurance: argsRequest.insurance,
                    //partnerMargin: argsRequest.partnerMargin,
                    agencyMargins: [],
                    additionalData: {},
                    preBook: argsRequest.paymentMethod.isOption == true ? true : false,
                    culture: $scope.selectDocumentsLanguage.toUpperCase()
                };

                bookingRQ.agencyMargins.push({
                    productType: 0,
                    margin: argsRequest.partnerMargin
                });

                //Add Accommodation
                if ($window.accommodation) {
                    bookingRQ.accommodations = [];
                    bookingRQ.accommodations.push($window.accommodation);

                    if (bkgData.agencyMarginHotel) {

                        bookingRQ.agencyMargins.push({
                            productType: 1,
                            margin: bkgData.agencyMarginHotel.value
                        });
                    }
                }
                //console.log("bookingRQ");
                //console.log(bookingRQ);

                bookingRQ.paymentMethod = argsRequest.paymentMethod;

                //Airbus Additional data            
                if (user && user.type === 6 && user.loginInfo != null && user.loginInfo.Matricule != null) {

                    if (bkgData.bookingRequest.airbusPayOption != null && bkgData.bookingRequest.airbusPayOption != undefined) {
                        bookingRQ.additionalData["airbus.payBalanceOption"] = bkgData.bookingRequest.airbusPayOption;
                    }
                    if (argsRequest.additionalData != null) {
                        if (argsRequest.additionalData["airbus.firstname"] != null) {
                            bookingRQ.additionalData["airbus.firstname"] = argsRequest.additionalData["airbus.firstname"];
                        }
                        if (argsRequest.additionalData["airbus.lastname"] != null) {
                            bookingRQ.additionalData["airbus.lastname"] = argsRequest.additionalData["airbus.lastname"];
                        }
                        if (argsRequest.additionalData["airbus.matricule"] != null) {
                            bookingRQ.additionalData["airbus.matricule"] = argsRequest.additionalData["airbus.matricule"];
                        }
                        if (argsRequest.additionalData["airbus.insurance"] != null) {
                            bookingRQ.additionalData["airbus.insurance"] = argsRequest.additionalData["airbus.insurance"];
                        }
                        if (argsRequest.additionalData["airbus.portable"] != null) {
                            bookingRQ.additionalData["airbus.portable"] = argsRequest.additionalData["airbus.portable"];
                        }
                        if (argsRequest.additionalData["airbus.telephone"] != null) {
                            bookingRQ.additionalData["airbus.telephone"] = argsRequest.additionalData["airbus.telephone"];
                        }
                        if (argsRequest.additionalData["airbus.referrer"] != null) {
                            bookingRQ.additionalData["airbus.referrer"] = argsRequest.additionalData["airbus.referrer"];
                        }
                    }
                }

                if (bkgData.bookingRequest.cECode != null && bkgData.bookingRequest.cECode != undefined) {
                    bookingRQ.additionalData["Ce.Code"] = bkgData.bookingRequest.cECode;
                }

                //Additional data
                if (argsRequest.holidayVoucher != undefined && argsRequest.holidayVoucher != false)
                    bookingRQ.additionalData["HolidayVoucher"] = argsRequest.holidayVoucher;

                if (argsRequest.discountCode != undefined)
                    bookingRQ.additionalData["DiscountCode"] = argsRequest.discountCode;

                if (argsRequest.GestourAgentLogin != undefined)
                    bookingRQ.additionalData["GestourAgentLogin"] = argsRequest.GestourAgentLogin;

                if (argsRequest.GestourClientMail != undefined)
                    bookingRQ.additionalData["GestourClientMail"] = argsRequest.GestourClientMail;

                if (argsRequest.qcns != undefined)
                    bookingRQ.additionalData["Qcns"] = argsRequest.qcns;

                if (argsRequest.cruiseNumber != undefined)
                    bookingRQ.additionalData["CruiseNumber"] = argsRequest.cruiseNumber;

                if (user.type === 6 && user.loginInfo != null && user.loginInfo.Matricule != null) {
                    bookingRQ.ceUser = user.loginInfo.Matricule;
                }

                if (existWonderboxCode)
                    bookingRQ.additionalData["WonderboxCode"] = bkgData.bookingRequest.wonderboxCode;


                if ($window.sessionStorage.getItem("ooofly_opeId")) {
                    bookingRQ.additionalData["opeId"] = $window.sessionStorage.getItem("ooofly_opeId");
                }

                if ($window.sessionStorage.getItem("cdiscountCustomerGuid"))
                    bookingRQ.additionalData["cdiscountCustomerGuid"] = $window.sessionStorage.getItem("cdiscountCustomerGuid");

                if ($window.sessionStorage.getItem("hasCdav"))
                    bookingRQ.additionalData["hasCdav"] = $window.sessionStorage.getItem("hasCdav");

                if (bkgData.bookingRequest.additionalData["insuranceWithFluo"]) {
                    bookingRQ.additionalData["insuranceWithFluo"] = bkgData.bookingRequest.additionalData["insuranceWithFluo"];
                }
                //AdditionalData in URL for WHITE LABELS
                if ($scope.enableSendParameters) {
                    var customURL = tseUtil.Location.getQueryStringVar("custom");
                    var campaignURL = tseUtil.Location.getQueryStringVar("campaign");

                    if (customURL) {
                        bookingRQ.additionalData["custom"] = customURL;
                    }

                    if (campaignURL) {
                        bookingRQ.additionalData["campaign"] = campaignURL;
                    }
                }

                //Passengers
                argsRequest.passengers.each(function (pax) {
                    var auxPaxPassportExpireDate = null;
                    var auxPaxBirthDate = moment(pax.birthDate, "DD-MM-YYYY");

                    if (pax.passportExpireDate != undefined)
                        auxPaxPassportExpireDate = moment(pax.passportExpireDate, "DD-MM-YYYY");

                    var auxPasenger = {
                        firstName: pax.firstName,
                        lastName: pax.lastName,
                        birthDate: auxPaxBirthDate.format("YYYY-MM-DD"),
                        index: pax.index,
                        type: pax.paxType,
                        phoneCountryCode: pax.phoneCountryCode,
                        ptc: pax.ptc,
                        title: pax.title,
                        passportNumber: pax.passportNumber,
                        passportCountry: pax.passportCountry,
                        additionalBaggages: [],
                        fidelityCardNumber: pax.fidelityCardNumber,
                        fidelityCard: pax.fidelityCardType
                    };
                    debugger;
                    if (pax.phoneCountryCode !== undefined && pax.phoneCountryCode !== '' && pax.phone !== undefined && pax.phone !== '')
                        auxPasenger.phone = libphonenumber.parsePhoneNumberFromString("+{0}{1}".format(pax.phoneCountryCode, pax.phone)).format("INTERNATIONAL").replace(/\s/g, "");

                    if (auxPaxPassportExpireDate != undefined)
                        auxPasenger.passportExpiry = auxPaxPassportExpireDate.format("YYYY-MM-DD");

                    if (pax.baggageByItinerary) {
                        for (var paxBaggage in pax.baggageByItinerary) {
                            if (pax.baggageByItinerary[paxBaggage].quantity > 0) {
                                if (pax.baggageByItinerary[paxBaggage]) {
                                    auxPasenger.additionalBaggages.push({
                                        itineraryKey: paxBaggage,
                                        baggageKey: pax.baggageByItinerary[paxBaggage].key,
                                        baggageId: pax.baggageByItinerary[paxBaggage].baggageId
                                    });
                                }
                            }
                        }
                    }

                    bookingRQ.passengers.push(auxPasenger);
                });

                //Tracking
                //$window.sendAnalytics('/Flightsearch/Bookingwait', 'Booking wait');

                //Tracking
                try {
                    //GTM
                    if (trackingService.isActivated()) {
                        trackingService.pushPageData('/Flightsearch/Bookingwait', 'Booking wait', lng, false);
                    }
                }
                catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }

                //$window.sendXiti("tunnel_resavol::attente_confirmation_site_resavol", 1);
                $window.sendInspectlet("pageUrl", $window.getUrl('Flightsearch/Bookingwait'));
                window.sendDoubleClick("recapvol", null, null, null, null);

                if (bookingRQ.accommodations != null && bookingRQ.accommodations.any()) {
                    if (bookingRQ.accommodations[0].rooms != null) {
                        bookingRQ.accommodations[0].rooms.each(function (room) {
                            if (room.passengers != null) {
                                //clone passengers to avoid error in date picker on back navigation
                                var passengers = $window.objectClone(room.passengers);
                                passengers.each(function (passenger) {
                                    var date = passenger.birthDate.toString();
                                    var newDate = date.substring(6, 10) + "-" + date.substring(3, 5) + "-" + date.substring(0, 2);
                                    passenger.birthDate = newDate;
                                });
                                room.passengers = passengers;
                            }
                        });
                    }
                }

                var selectedSeatsKey = 'selectedSeats_' + bookingRQ.purchaseId;

                var sessionSeats = window.sessionStorage.getItem(selectedSeatsKey);
                if (sessionSeats != null) {
                    var selection = JSON.parse(sessionSeats);

                    angular.forEach(selection, function (segment, key) {

                        var segmentKey = key;

                        angular.forEach(selection[key], function (select, key) {

                            for (var i = 0; i < bookingRQ.passengers.length; i++) {
                                if (bookingRQ.passengers[i].index == select.passenger.index) {
                                    if (bookingRQ.passengers[i].segmentSeats == null) {
                                        bookingRQ.passengers[i].segmentSeats = [];
                                    }
                                    var segementSeat = {
                                        //choice :,
                                        segmentKey: segmentKey,
                                        //deckLevel = ss.DeckLevel,
                                        //coach = ss.Coach,
                                        providerKey: select.seat.providerKey,
                                        //rowIndex = ss.RowIndex,
                                        seatNumber: select.seat.number
                                    };

                                    bookingRQ.passengers[i].segmentSeats.push(segementSeat);

                                    console.log("PAX SEATS");
                                    console.log(bookingRQ.passengers[i].segmentSeats);
                                }
                            }

                        });
                    });
                }

                console.log("OPE_ID: " + bookingRQ.additionalData["opeId"]);
                var elkMessage = window['Typescript']['Services']['ElasticSearchService'].createMessage('CreateBooking');

                elkMessage.requestId = argsRequest.requestId;
                elkMessage.messageRequest = bookingRQ;
                elkMessage.purchaseId = argsRequest.purchaseId;
                elkMessage.paymentId = argsRequest.paymentMethod.paymentMethodId;


                if ($scope.enableFreeFlex) {
                    //Add free flex to create booking

                    //Add total flex if selected
                    var totalflexSelected = window.sessionStorage.getItem("inssurance.totalflex.selected") === 'true';
                    if (totalflexSelected === true) {
                        //Get assurance Id

                    }
                }

                //Call to API
                $scope.apiClient.PURCHASE.createBooking(bookingRQ)
                    .success(function (data, code) {
                        elkMessage.statusCode = code;
                        elkMessage.messageResponse = data;
                        if (data && data.bookingId) {
                            if (!$scope.hideSpecialRequest) {
                                if ($scope.assistanceRequests) {
                                    // PUT SPECIAL REQUEST 
                                    var data;
                                    var urlApi = "";
                                    switch ($scope.assistanceRequests[0].type) {
                                        case 0://ASSISTANCE
                                            urlApi = "/api/api/specialrequest/PutAssistanceRequestAsync";
                                            break;
                                        case 1:
                                            //ANIMAL
                                            urlApi = "/api/api/specialrequest/PutPetsRequestAsync";
                                            break;
                                        case 2:
                                            //LUGGAGE
                                            urlApi = "/api/api/specialrequest/PutLuggageRequestAsync";
                                            break;
                                    }
                                    $scope.assistanceRequests[0].bookingId = data.bookingId;
                                    $scope.assistanceRequests[0].agentId = $window.site.loginInfo.Agent.AgentId;
                                    var dataRequest = JSON.stringify($scope.assistanceRequests);
                                    $.ajax({
                                        url: urlApi,
                                        type: 'post',
                                        dataType: 'json',
                                        contentType: 'application/json; charset=utf-8',
                                        data: dataRequest,
                                        async: false,
                                        success: function (result) {
                                            if (result) {
                                                sessionStorage.removeItem('assistanceRequestStep1');
                                                localStorage.setItem('assistancesRequest' + '-' + data.bookingId, JSON.stringify(dataRequest));
                                            }
                                        },
                                        error: function (result, status, error) {
                                        }
                                    });
                                }
                            }
                            
                            bkgData.bookingResponse = data;

                            var paymentUrl = "";
                            //OK saved!
                            //console.log("SAVE:" + bkgData.agencyMarginHotel);
                            tseUtil.Session.set('bkgData_' + $window.site.currentAirRequest.requestId, bkgData);
                            paymentUrl = tseUtil.Url.appendValueToUrlBefore($window.site.currentAirRequest.paymentUrl, "brqid", data.bookingId);

                            if (paymentUrl != "")
                                $window.location.href = paymentUrl;
                        }
                    }).error(function (data, code) {
                        elkMessage.statusCode = code;
                        elkMessage.messageResponse = data;

                        // $window.FLoading({ vAction: 'hide' });
                        window.mrflyWidgets['mrfly-widget-loader-component'].$store.commit("hideLoader");
                        $(".c-footer").removeClass("d-none");
                        if (code == 400) {
                            $window.XLConfirm({
                                vTitle: $i18next.t("airbooking.yoursessionlost"), vTextYes: "OK", vHideNo: true, fCallBackYes: function () {
                                    $window.location.href = $window.site.loginUrl;
                                }
                            });
                        }
                        if (code == 410) {
                            $window.XLConfirm({
                                vTitle: $i18next.t("airbooking.yoursessionlost"), vTextYes: "OK", vHideNo: true, fCallBackYes: function () {
                                    $window.redoSearch();
                                }
                            });
                        }
                        if (code == 412) {
                            $window.XLConfirm({
                                vTitle: $i18next.t("airbooking.pleasetheform"), vTextYes: "OK", vHideNo: true
                            });
                        }
                    }).finally(function () {
                        elkService.store(elkMessage);
                    });
            });



            //PURCHASE Payment Methods
            $scope.$on("getPurchasePaymentMethods",
                function (event, args) {
                    var argsPaymentMethodsRequest = window.objectClone(args);
                    var nextStep = argsPaymentMethodsRequest.value;
                    $window.FLoading({ vAction: 'show' });
                    var paymentMethodsRq = {
                        requestId: bkgData.bookingRequest.requestId,
                        purchaseId: bkgData.purchaseResponse.purchaseId,
                        proposalIndex: bkgData.bookingRequest.proposalIndex,
                        passengers: []
                    }

                    if (bkgData.bookingRequest.insurance != null) {
                        paymentMethodsRq.insurance = bkgData.bookingRequest.insurance;
                        paymentMethodsRq.insurance.flexy = bkgData.bookingRequest.flexyFare;
                    }
                    else if (bkgData.bookingRequest.flexyFare == true)
                        paymentMethodsRq.insurance = { flexy: true };

                    if (user.type === 6 && user.loginInfo != null && user.loginInfo.Matricule != null) {
                        paymentMethodsRq.ceUser = user.loginInfo.Matricule;
                    }

                    //Passengers
                    bkgData.bookingRequest.passengers.each(function (pax) {
                        var auxPaxPassportExpireDate = null;
                        var auxPaxBirthDate = moment(pax.birthDate, "DD-MM-YYYY");

                        if (pax.passportExpireDate != undefined)
                            auxPaxPassportExpireDate = moment(pax.passportExpireDate, "DD-MM-YYYY");

                        var auxPasenger = {
                            firstName: pax.firstName,
                            lastName: pax.lastName,
                            birthDate: auxPaxBirthDate.format("YYYY-MM-DD"),
                            index: pax.index,
                            type: pax.paxType,
                            phoneCountryCode: pax.phoneCountryCode,
                            ptc: pax.ptc,
                            title: pax.title,
                            passportNumber: pax.passportNumber,
                            passportCountry: pax.passportCountry,
                            additionalBaggages: [],
                            fidelityCardNumber: pax.fidelityCardNumber,
                            fidelityCard: pax.fidelityCardType
                        };

                        if (pax.phoneCountryCode != undefined && pax.phone != undefined)
                            auxPasenger.phone = libphonenumber.parsePhoneNumberFromString("+{0}{1}".format(pax.phoneCountryCode, pax.phone)).format("INTERNATIONAL").replace(/\s/g, "");

                        if (auxPaxPassportExpireDate != undefined)
                            auxPasenger.passportExpiry = auxPaxPassportExpireDate.format("YYYY-MM-DD");

                        if (pax.baggageByItinerary) {
                            for (var paxBaggage in pax.baggageByItinerary) {
                                if (pax.baggageByItinerary[paxBaggage].quantity > 0) {
                                    if (pax.baggageByItinerary[paxBaggage]) {
                                        auxPasenger.additionalBaggages.push({
                                            itineraryKey: paxBaggage,
                                            baggageKey: pax.baggageByItinerary[paxBaggage].key,
                                            baggageId: pax.baggageByItinerary[paxBaggage].baggageId
                                        });
                                    }
                                }
                            }
                        }

                        paymentMethodsRq.passengers.push(auxPasenger);
                    });

                    var elkMessage = window['Typescript']['Services']['ElasticSearchService'].createMessage('PaymentMethods');

                    elkMessage.requestId = $window.site.currentAirRequest.requestId;
                    elkMessage.purchaseId = bkgData.purchaseResponse.purchaseId;
                    elkMessage.messageRequest = paymentMethodsRq;

                    //Call to API
                    $scope.apiClient.PURCHASE.paymentMethods(paymentMethodsRq).success(function (data, code) {
                        elkMessage.statusCode = code;
                        elkMessage.messageResponse = data;
                        $window.FLoading({ vAction: 'hide' });
                        $(".c-footer").removeClass("d-none");
                        if (data) {
                            bkgData.paymentMethods = data.paymentMethods;
                        }
                        if (nextStep >= 0)
                            $scope.$emit("setReadyStep", { step: nextStep });

                        $scope.$broadcast("getBanqueCasinoScheduleCallback");
                    }).error(function (data, code) {
                        elkMessage.statusCode = code;
                        elkMessage.messageResponse = data;

                        console.log(data);
                        console.log(code);
                        $window.FLoading({ vAction: 'hide' });
                        $(".c-footer").removeClass("d-none");
                        if (nextStep >= 0)
                            $scope.$emit("setReadyStep", { step: nextStep });

                        $scope.$broadcast("getBanqueCasinoScheduleCallback");
                    }).finally(function () {
                        elkService.store(elkMessage);
                    });
                });



            //Prediction Object
            $scope.preparePredictionsObject = function () {
                //Get Price Predictions
                var rqPredictions = {
                    price: bkgData.purchaseResponse.proposals[0].totalAmount.value,
                    itineraries: []
                };
                bkgData.purchaseResponse.itineraries.each(function (it) {
                    var itAux = {
                        origin: it.origin.airportIata,
                        destination: it.destination.airportIata,
                        airline: it.marketingCarrier.iata,
                        stops: it.segments.length - 1,
                        date: it.date
                    };
                    rqPredictions.itineraries.push(itAux);
                });
                return rqPredictions;
            };


            //Taxes details click
            $scope.$on("displayTaxesDetailsClick", function (event, args) {
                $scope.displayTaxesDetailModal = true;
                $scope.modalTaxesKey = args.key.replaceAll(":", "-");
                $scope.modalTaxesKey = $scope.modalTaxesKey.replaceAll("\\|", "-");
                $scope.modalTaxesKeyAux = $scope.modalTaxesKey + "-" + args.paxFares.paxType;
                $scope.modalTaxesPaxFares = args.paxFares;

                $scope.$broadcast("updateTaxesDetailModalData", { key: $scope.modalTaxesKey, fares: $scope.modalTaxesPaxFares });

                $scope.modalShowMargin = false;

                var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

                args.marketingCarriers.each(function (value, key) {

                    if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                        $scope.modalShowMargin = true;
                    }
                });

                //Remodal workaround
                $(document).find(".remodal").each(function (a, c) {
                    var d = $(c), e = d.data("remodal-options");
                    e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                        d["remodal"](e)
                });

                $timeout(function () {
                    $('[data-remodal-id=' + 'taxes-detail-modal-' + $scope.modalTaxesKeyAux + ']').remodal().open();
                },
                    200, false);
            });

            //Luaggage details click
            $scope.$on("displayLuggageDetailsClick", function (event, args) {
                $scope.displayLuggageDetailModal = true;
                $scope.modalLuggageBagType = args.bagType;

                $scope.$broadcast("updateLuggageDetailModalData", { bagType: $scope.modalLuggageBagType });

                $scope.modalShowMargin = false;

                var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

                args.marketingCarriers.each(function (value, key) {

                    if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                        $scope.modalShowMargin = true;
                    }
                });

                //Remodal workaround
                $(document).find(".remodal").each(function (a, c) {
                    var d = $(c), e = d.data("remodal-options");
                    e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                        d["remodal"](e)
                });

                $timeout(function () {
                    $('[data-remodal-id="luggage-detail-modal"]').remodal().open();
                },
                    200, false);
            });

            //AIRBUS
            $scope.$on("selectAirbusInsurance", function (event, args) {
                bkgData.bookingRequest.isAirbusInsuranceSelected = true;
                bkgData.bookingRequest.isAirbusInsuranceUncheked = false;
            });

            $scope.$on("rejectAirbusInsurance", function (event, args) {
                bkgData.bookingRequest.isAirbusInsuranceSelected = false;
                bkgData.bookingRequest.isAirbusInsuranceUncheked = true;
            });

            $scope.$on("selectAirbusPaymentBalanceOption", function (event, args) {
                bkgData.bookingRequest.airbusPayOption = args.airbusPayOption;
            });

            $scope.$on("onAssistanceRequestSave", function (event, assistanceRequests) {
                $scope.assistanceRequests = assistanceRequests;
            });
        }
        else {
            $window.FLoading({ vAction: 'show' });
            window.location.href = searchUrl;
        }
    }]);
